import settings from '/@/core/settings';
import type { Paginated } from '/@/store/crop-monitoring-notes/apiProviders';
import { axFetch } from '/@/store/session/actions';
import type { Claim, ClaimInput, ClaimStatus } from '/@/types/claim';

const BASE = () => `${settings.urls.apiDomain}/core/v1/crop-monitoring/claims`;

export interface ClaimFilters {
    field?: number;
    dateGte?: string;
    dateLte?: string;
    status?: ClaimStatus;
    ordering?: string;
    page?: number;
    pageSize?: number;
}

export async function getClaims(filters: ClaimFilters = {}): Promise<Paginated<Claim>> {
    const params = new URLSearchParams();
    if (filters.field !== undefined) params.append('field', String(filters.field));
    if (filters.dateGte) params.append('date__gte', filters.dateGte);
    if (filters.dateLte) params.append('date__lte', filters.dateLte);
    if (filters.status) params.append('status', filters.status);
    if (filters.ordering) params.append('ordering', filters.ordering);
    if (filters.page) params.append('page', String(filters.page));
    if (filters.pageSize) params.append('page_size', String(filters.pageSize));

    const res = await axFetch.get(`${BASE()}/?${params.toString()}`);
    return res.data;
}

export const createClaim = async (data: ClaimInput): Promise<Claim> => {
    const res = await axFetch.post(`${BASE()}/`, data);
    return res.data;
};

export const updateClaim = async (id: number, data: ClaimInput): Promise<Claim> => {
    const res = await axFetch.patch(`${BASE()}/${id}/`, data);
    return res.data;
};

export const deleteClaim = async (id: number): Promise<void> => {
    await axFetch.delete(`${BASE()}/${id}/`);
};
